import separator from '../../assets/images/separator.svg';

export const Separator = () => <img src={separator} alt=">" style={{ margin: '14px', width: '12px', height: '12px' }} />;
